<template>
	<drawer
			:title="titleDrawer"
			z-index="100"
			@updateClose="onClose"
			@updateSave="onSave"
	>
		<field
				:class-error="$v.type && $v.type.$error"
				margin="0 0 10px 0"
				label="Type"
				placeholder="Select type"
				@updateAutocomplete="onAutocomplete($event, 'type')"
				:autocompleteValue="type"
				:items="paymentsTypes"
				:isClearable="false"
				is-autocomplete
				is-required
				is-attach
		></field>
		<field
				:class-error="$v.msg && $v.msg.$error"
				margin="0 0 10px 0"
				width="300px"
				label="Note"
				placeholder="Enter note"
				:setInputValue="msg"
				@updateInput="onInput($event, 'msg')"
				is-textarea
				is-required
		></field>
		<field
				:class-error="$v.amount && $v.amount.$error"
				margin="0 0 10px 0"
				width="300px"
				label="Amount"
				placeholder="Select amount"
				type="number"
				:setInputValue="amount"
				@updateInput="onInput($event, 'amount')"
				is-required
				icon="dollar"
		></field>
		<field
				margin="10px 0 10px 0"
				overflow="hidden"
				padding="0"
				height="24"
				labelSwitch="Include in total gross"
				:switch-value="considerBoolean"
				@updateSwitch="onCheckbox($event, 'considerBoolean')"
				is-dense
				is-checkbox
				is-off-style
				:is-disabled="isDisabledConsider"
		></field>
	</drawer>
</template>

<script>
import Drawer from "@/shared/Drawer/Drawer";
import { validationMixin } from "vuelidate";
import { minValue, required } from "vuelidate/lib/validators";
import { paymentsTypes } from "@/components/Dispatch/Trips/DialogTrip/constants";

export default {
	name: "PaymentsDrawer",
	mixins: [ validationMixin ],
	components: { Drawer },
	props: {
		activeItem: Object,
		isDisabledConsider: Boolean,
	},
	validations: {
		amount: { required, minValueValue: minValue(0.1) },
		msg: { required },
		type: { required },
	},
	computed: {
		paymentsTypes() {
			return paymentsTypes;
		},
	},
	data() {
		return {
			titleDrawer: 'Add payment',
			type: 1,
			considerBoolean: false,
			amount: null,
			msg: '',
		};
	},
	methods: {
		onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const { amount, msg, type, considerBoolean } = this.$data;
				this.$emit('updateSave', { amount: parseFloat(amount), msg, type, considerBoolean }, this.activeItem);
			} else {
				this.$store.dispatch('setAlert', { type: "error", message: "Saving error" });
			}
		},
		onClose() {
			this.$emit('updateClose');
		},
		onInput({ value }, key) {
			this[key] = value;
		},
		onAutocomplete({ value }, key) {
			this[key] = value.id;
		},
		onCheckbox({ value }, key) {
			this[key] = value;
		},
	},
	mounted() {
		if (this.activeItem) {
			const { type, considerBoolean, amount, msg } = this.activeItem;
			this.titleDrawer = 'Edit payment';
			this.type = type;
			this.considerBoolean = considerBoolean;
			this.amount = amount;
			this.msg = msg;
		}
	}
};

</script>
